import sqlServerInstancesReducer from './sqlServerInstancesReducer';
import agentReducer from './agentReducer';
import appReducer from './appReducer';
import imageReducer from './imageReducer';
import operationProgressReducer from './operationProgressReducer';
import cloneReducer from './cloneReducer';
import operationsReducer from './operationsReducer';
import { reducer as formReducer } from 'redux-form';
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import imageDestinationLocationsReducer from './imageDestinationLocationsReducer';
import instanceDetailsReducer from './instanceDetailsReducer';
import backupLocationsReducer from './backupLocationsReducer';
import usersReducer from './usersReducer';
import tourReducer from './tourReducer';
import permissionsReducer from './permissionsReducer';


const rootReducer = combineReducers({
    agents: agentReducer,
    images: imageReducer,
    clones: cloneReducer,
    sqlServerInstances: sqlServerInstancesReducer,
    backupLocations: backupLocationsReducer,
    imageDestinationLocations: imageDestinationLocationsReducer,
    operations: operationsReducer,
    instanceDetails: instanceDetailsReducer,
    operationProgress: operationProgressReducer,
    users: usersReducer,
    permissions: permissionsReducer,
    routing: routerReducer,
    form: formReducer,
    app: appReducer,
    tour: tourReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/js/reducers/index.js